import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["orgSelect", "pdfLink"]
  static values  = { pdfUrl: String }

  updatePdfLink() {
    const includeTickets = this.orgSelectTarget.value
    const url = includeTickets ? `${this.pdfUrlValue}?include_tickets=true` : this.pdfUrlValue
    this.pdfLinkTarget.href = url
  }
}
